import React from 'react';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';
import { AlertTriangle } from 'lucide-react';

function Disclaimer() {
  return (
    <Alert variant="default" className="border-yellow-500/50 bg-yellow-500/10 dark:bg-yellow-500/5">
      <AlertTriangle className="h-4 w-4 text-yellow-600 dark:text-yellow-500" />
      <AlertTitle className="text-yellow-900 dark:text-yellow-100">Disclaimer</AlertTitle>
      <AlertDescription className="text-yellow-800 dark:text-yellow-200 space-y-2">
        <p>
          All player statistics, comparisons, and analysis on this platform are 
          <strong> AI-generated for entertainment and fan discussion purposes only</strong>. 
          While the AI strives to provide realistic data based on historical knowledge, 
          the information should not be considered as official or verified statistics. 
          Always refer to official sources for accurate player data and statistics.
        </p>
        <p className="text-sm opacity-90">
          This application uses free AI services and may have limitations in accuracy 
          and data freshness. Use at your own discretion.
        </p>
      </AlertDescription>
    </Alert>
  );
}

export default Disclaimer;
